module.exports = __webpack_public_path__ + "static/media/faster-cures.287ee52e.jpg";